mutation DeleteNote($input: DeleteNoteInput!) {
    noteDelete(input: $input) {
        note {
            id
        }
    }
}
